<template>
  <div class="nav">
    <el-row class="nav-inner">
      <el-col :span="6">
        <img
          class="logo"
          @click="$router.push('/')"
          style="cursor: pointer"
          src="../assets/logo.png"
          alt=""
      /></el-col>
      <el-col class="nav-item hidden-sm-and-down" :span="18">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            解决方案<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="index"
              v-for="(item, index) in navList"
              :key="index"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <span @click="$router.push('/aboutus')">关于碰撞</span>
      </el-col>
      <el-col :span="18" class="hidden-md-and-up nav-right">
        <img
          @click="show = true"
          style="cursor: pointer"
          src="../assets/nav.png"
          alt=""
      /></el-col>
    </el-row>
    <el-row class="nav-md" v-if="show">
      <el-row class="nav-inner">
        <el-col :span="6">
          <img
            class="logo"
            @click="$router.push('/')"
            style="cursor: pointer"
            src="../assets/logo.png"
            alt=""
        /></el-col>
        <el-col :span="18" class="hidden-md-and-up nav-right">
          <img
            @click="show = false"
            style="cursor: pointer"
            src="../assets/nav1.png"
            alt=""
            height="38%"
        /></el-col>
      </el-row>
      <el-row class="nav-md-bottom">
        <el-col class="nav-md-bottom-left">
          <div
            class="nav-md-item"
            :class="active == 1 ? 'active' : ''"
            @click="active = 1"
          >
            解决方案
          </div>
          <div
            class="nav-md-item"
            :class="active == 2 ? 'active' : ''"
            @click="
              active = 2;
              $router.push('/aboutus');
            "
          >
            关于碰撞
          </div>
        </el-col>
        <el-col v-if="active == 1" class="nav-md-bottom-right" :span="18">
          <div
            v-for="(item, index) in navList"
            :key="index"
            @click="$router.push(item.path)"
          >
            {{ item.name }}
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import "element-ui/lib/theme-chalk/display.css";
export default {
  data() {
    return {
      show: false,
      active: 1,
      navList: [
        {
          name: "智慧文旅",
          path: "/wenBrigade",
        },
        {
          name: "智慧农业",
          path: "/agricultural",
        },
        {
          name: "智慧政务",
          path: "/security",
        },
      ],
    };
  },
  // mounted() {
  //   window.addEventListener('scroll',()=>{
  //     console.log(document.documentElement.scrollTop);
  //   })

  // },
  methods: {
    handleCommand(val) {
      if (this.$route.path != this.navList[val].path) {
        this.$router.push(this.navList[val].path);
      }
    },
  },
};
</script>
<style lang="less" scope>
.nav {
  width: 100%;
  background-color: #242b43;
  .nav-inner {
    width: 952px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    color: #ffffff;
    .logo {
      height: 48px;
    }
    .el-dropdown-link {
      color: #ffffff;
      font-size: 16px;
      margin-right: 30px;
    }
    .nav-item {
      display: flex;
      justify-content:flex-end;
      span {
        cursor: pointer;
      }
    }
    .nav-right {
      text-align: right;
      img {
        height: 30px;
      }
    }
  }
}
.nav-md {
  display: none;
}
@media screen and (max-width: 992px) {
  .nav {
    .nav-inner {
      width: 95%;
      .logo {
        height: 42px;
      }
    }
  }
  .nav-md {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #242b43;
    z-index: 100;
    display: block;
    .nav-md-bottom {
      border-top: 0.5px solid rgba(255, 255, 255, 0.2);
      height: calc(100% - 80px);
      color: #fff;
      display: flex;
      .nav-md-bottom-left {
        width: 150px;
        background-color: #141929;
        height: 100%;
        text-align: center;
        padding-top: 30px;
        box-sizing: border-box;
        div {
          line-height: 50px;
        }
        .active {
          background-color: #242b43;
        }
      }
      .nav-md-bottom-right {
        padding-left: 20px;
        box-sizing: border-box;
        div {
          border-bottom: 0.5px solid rgba(255, 255, 255, 0.2);
          line-height: 50px;
          cursor: pointer;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .nav,
  .nav-md {
    .nav-inner {
      width: 90%;
      height: 65px;
      .logo {
        height: 30px;
      }
      .nav-right {
        img {
          height: 20px;
        }
      }
    }
  }
  .nav-md {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #242b43;
    z-index: 100;
    .nav-md-bottom {
      border-top: 0.5px solid rgba(255, 255, 255, 0.2);
      height: calc(100% - 65px);
      color: #fff;
      display: flex;
      .nav-md-bottom-left {
        width: 150px;
        background-color: #141929;
        height: 100%;
        text-align: center;
        padding-top: 30px;
        box-sizing: border-box;
        div {
          line-height: 50px;
        }
        .active {
          background-color: #242b43;
        }
      }
      .nav-md-bottom-right {
        padding-left: 20px;
        box-sizing: border-box;
        div {
          border-bottom: 0.5px solid rgba(255, 255, 255, 0.2);
          line-height: 50px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>